<template>
  <tr>
    <td class="crpg-m-free-food-shop-list shop">
      {{ shopListName }}
      <span class="category">
        {{ shopListCategory }}
      </span>
      <span class="area">
        {{ shopListArea }}
      </span>
    </td>
    <td class="crpg-m-free-food-shop-list-course course">
      {{ shopListCourse }}
    </td>
    <td class="crpg-m-free-food-shop-list-price price">{{ shopListPrice }}</td>
  </tr>
</template>

<script>
export default {
  props: {
    shopListName: String,
    shopListCategory: String,
    shopListArea: String,
    shopListCourse: String,
    shopListPrice: String,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/molecules/freeFood/shopList.scss";
</style>
